import React, {useState} from "react";
import moment from "moment";
import * as Item from "../../../booking/components/services/Item";
import { ArrowLongRightIcon } from "@heroicons/react/20/solid";
import { faCar, faSquareParking } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteModal from "../../../shared/components/DeleteModal";
import {useTranslation} from "react-i18next";
import {OrangeButton, WhiteButton} from "../../../shared/components/Buttons";
import {faCircle} from "@fortawesome/free-regular-svg-icons";

const CustomItem = ({ item, icon, isActive, onSelect = null, onRemove = null, disabled, editable }) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <Item.Root
            Icon={
                <FontAwesomeIcon icon={faCircle} className="text-sm text-gray-500" />
            }
            isActive={isActive}
            disabled={disabled}
        >
            <Item.Heading>
                <Item.Title>
                    {item.label}
                </Item.Title>
                <Item.Subtitle hideOnOpen={false}>
                    <Item.Date date={moment(item.date)} />
                </Item.Subtitle>
            </Item.Heading>
            <Item.Body>
                <WhiteButton
                    disabled={disabled}
                    type="button"
                    onClick={() => {setOpen(true)}}
                >
                    {t("booking.delete")}
                </WhiteButton>
                <DeleteModal title="Êtes vous certain ?" open={open} setOpen={setOpen} onConfirm={onRemove}>
                    Vous allez supprimer un service personnalisé.
                </DeleteModal>
            </Item.Body>
        </Item.Root>
    );
}
export default CustomItem;
